import React from 'react'

// containers
import ModalWrapper from 'components/shared/ModalWrapper'

// components
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

// data
import { useBrand } from 'components/shared/SettingsProvider'

const Question = ({ children }) => {
  return <Typography variant='h4'>{children}</Typography>
}

const Answer = ({ children }) => {
  return (
    <Typography py={1} variant='body1'>
      {children}
    </Typography>
  )
}

const OnlineHelpModal = props => {
  const { shortName, marcomUrl } = useBrand()

  return (
    <ModalWrapper title='How it Works' modalId='onlineHelp' closeButton>
      <Answer>
        Welcome to {shortName} Virtual Camp - we are so glad you are here.
        Please check out the following tips and tricks for taking advantage of
        all {shortName} Virtual Camp has to offer.
      </Answer>

      <Question>How do I find more information or join an activity?</Question>
      <Answer>
        Each day you will see all available activities, their start times, the
        staff member facilitating the activity, and a description. All
        activities are designed to be done with or without materials at home -
        however, some sessions are enhanced by having some paper and markers or
        other household materials on hand. You can find a list of suggested
        materials each day in the activity description.
      </Answer>
      <Answer>
        To join a room you simply locate any room with a "live now" label, click
        on the activity name, and in the resulting popup select "Join Now". This
        will automatically open the Zoom Room. If you change your mind, the
        "Maybe Later" button will take you back to the {shortName} Virtual Camp
        screen.
      </Answer>

      <Question>Do I need to stay the whole time?</Question>
      <Answer>
        When participating in {shortName} Virtual Camp, children can jump from
        one activity to another until they find the right activity choice for
        them. In fact, we have several sessions that coordinate throughout the
        day that encourage collaboration. If your camper wants to choose another
        activity, they can simply leave the current Zoom room and select another
        from the Virtual Camp screen.
      </Answer>

      <Question>What is {shortName} doing to keep my camper safe?</Question>
      <Answer>
        At {shortName}, safety is our highest priority. In order to ensure
        camper safety several steps are taken:
      </Answer>
      <Answer>
        All families are strongly encouraged to read our{' '}
        <Link
          target='_blank'
          href={`${marcomUrl}/online-guidelines-and-safety/`}
        >
          Community Guidelines and Safety Standards
        </Link>
        .
      </Answer>
      <Answer>
        To prevent “Zoom bombing”, the identity of all campers must be confirmed
        by showing their video when joining a room, before turning their camera
        off if they so choose. All of our Zoom meetings have a randomly
        generated password which is not provided to campers. Authentication
        happens through our {shortName} registration system only, which prevents
        anyone outside of the organization from being able to gain access.
      </Answer>

      <Question>Need Help?</Question>
      <Answer>
        Give us a call or text during camp hours at (415) 223-0038 or email us
        at{' '}
        <Link underline='always' href='mailto:virtualcamp@steveandkate.com'>
          virtualcamp@steveandkate.com
        </Link>
        .
      </Answer>
    </ModalWrapper>
  )
}

export default OnlineHelpModal
